export default "__VITE_ASSET__f7f462d0__"